import { numberFormat } from 'shared/lib'
import { smartRound } from 'entities/Billing/lib/smartRound.ts'
import { type IResponseGetBillingPreviewTaxRate } from 'entities/Billing/api/types.ts'

export const getTaxes = ({
  tax_rates,
  taxes_amount,
}: {
  tax_rates: IResponseGetBillingPreviewTaxRate[]
  taxes_amount: number
}) => {
  const tax_rate = tax_rates ? tax_rates[0] : null
  if (!tax_rate) return null
  const jurisdiction = tax_rate.jurisdiction
  const percent = smartRound(tax_rate.percent, 1)
  const title = `Sales tax - ${jurisdiction} (${percent}%)`
  return {
    total: numberFormat({
      value: taxes_amount / 100,
      currency: 'USD',
      minimumFractionDigits: 2,
    }),
    percent,
    jurisdiction,
    title,
  }
}
